import createPalette from '@mui/material/styles/createPalette';
import { alpha } from '@mui/system/colorManipulator';

const textPrimary = '#243748';

const palette = createPalette({
  primary: {
    main: '#0C6FB6',
    light: '#E6F4FD',
  },
  secondary: {
    main: '#29DBC2',
    light: '#E5FCFA',
    contrastText: alpha(textPrimary, 0.9),
  },
  error: {
    main: '#F70707',
  },
  warning: {
    main: '#F78307',
    light: '#F0E743',
  },
  info: {
    main: '#3E17EB',
  },
  success: {
    main: '#259427',
  },
  common: {
    black: '#080808',
    white: '#FFFFFF',
  },
  text: {
    primary: textPrimary,
    secondary: alpha(textPrimary, 0.9),
    disabled: alpha(textPrimary, 0.4),
  },
  grey: {
    50: '#F2F5F7',
    100: '#757375',
  },
  background: {
    default: '#F9FDFF',
    paper: '#fff',
  },
  action: {
    selectedOpacity: 0.1,
  },
});

export default palette;
